import "./WholesaleBenefits.css"
import { FaIndustry, FaTags, FaGem, FaShippingFast } from "react-icons/fa"

function WholesaleBenefits(){

return(

<div className="benefitsSection">

<h2 className="benefitsTitle">Why Buy From Us</h2>

<div className="benefitsGrid">

<div className="benefitCard">
<FaIndustry className="benefitIcon"/>
<h3>Factory Direct Prices</h3>
<p>Best wholesale prices for boutiques.</p>
</div>

<div className="benefitCard">
<FaTags className="benefitIcon"/>
<h3>Bulk Discounts</h3>
<p>Special discounts on large orders.</p>
</div>

<div className="benefitCard">
<FaGem className="benefitIcon"/>
<h3>Premium Quality</h3>
<p>High quality lace and accessories.</p>
</div>

<div className="benefitCard">
<FaShippingFast className="benefitIcon"/>
<h3>Fast Dispatch</h3>
<p>Quick shipping across India.</p>
</div>

</div>

</div>

)

}

export default WholesaleBenefits